import { controls } from "../../controls";


const vehicle = {
  label: "Vehicle Loan Details",
  pageLabel: "Vehicle Loan Details",
  starting: true,
  url: "vehicle",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ star: true, label: "Security", width: "col-sm-2" }),
    ...controls.Security({ isRequired: true, width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-8" }),
    // ...controls.showData({data: "branch_display", name: "branch_display",width:"col-sm-2"}),
    ...controls.displayText({ width: "col-sm-2", label: "Vehicle Type" }),
    ...controls.VehicleType({ width: "col-sm-2" }),
    ...controls.showData({ data: "vehicletype_display", name: "vehicletype_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Dealer", width: "col-sm-2" }),
    ...controls.text({ name: "dealer", width: "col-sm-4", placeHolder: "Dealer" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Vehicle Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "vehicle_amount", width: "col-sm-4", placeHolder: "Vehicle Amount" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Sanction Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "sanction_amount", width: "col-sm-4", placeHolder: "Sanction Amount" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Margine Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "margine_amount", width: "col-sm-4", placeHolder: "Margine Amount" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Engine Number", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Engine Number", name: "engine_no", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Chassis Number", width: "col-sm-2" }),
    ...controls.text({ name: "chassis_number", width: "col-sm-4", placeHolder: "Chassis Number" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Vehicle Number", width: "col-sm-2" }),
    ...controls.text({ name: "vehicle_number", width: "col-sm-4", placeHolder: "Vehicle Number" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "License Number", width: "col-sm-2" }),
    ...controls.text({ name: "license_number", width: "col-sm-4", placeHolder: "License Number" }),
    ...controls.displayText({ width: "col-sm-6" }),


  ]
}

export default vehicle;